import type {
  Asset,
  FolderAsset,
  VersionStackAsset,
} from '@frameio/graphql-client/generated';
import { getLink } from '@frameio/shared/routing/getLink';
import { useQuickSearchAssetResultLinkFragment } from '../gql/generated/QuickSearchAssetResultLink';

export const useGetAssetLink = (id: string) => {
  /**
   * new fragment with
   * - project.id
   * - parent.id
   */
  const { data } = useQuickSearchAssetResultLinkFragment({
    from: { id, __typename: 'Asset' },
  });

  const { parent, project } = data as Asset;

  let href;

  const projectId = project?.id;
  if (!id || !projectId) {
    return '';
  }

  if ((data as FolderAsset).__typename === 'FolderAsset') {
    href = getLink({
      page: 'folder',
      folderAssetId: id,
      projectId,
    });
  } else {
    const versionId =
      (parent as VersionStackAsset)?.__typename === 'VersionStackAsset'
        ? id
        : undefined;
    href = getLink({
      page: 'folderViewer',
      versionId,
      projectId,
      assetId: versionId && parent ? parent?.id : id,
    });
  }

  return href ? href.toString() : '';
};
